var html=`
<div id="main_div_draggable" style="font-family:Arial; font-size:13px; margin-bottom:0px; margin-left:8px; margin-right:0px; margin-top:0px; width:250px">
<div style="margin:auto; text-align:center"><img src ="https://media.istockphoto.com/id/981368726/vector/restaurant-food-drinks-logo-fork-knife-background-vector-image.jpg?s=612x612&w=0&k=20&c=9M26CBkCyEBqUPs3Ls5QCjYLZrB9sxwrSFmnAmNCopI=" height="80px" style="margin-left:5px;"></div>
<div style="float:left; text-align:center; width:100%">
<div style="font-size:14px; font-weight:900; margin-bottom:5px; margin-left:5px; margin-right:5px; margin-top:5px"><RESTAURANTNAME>Al Arabiyas</RESTAURANTNAME></div>
<div style="font-size:12px"><ADDRESS1>#306, 28A/9A,</ADDRESS1></div>
<div style="font-size:12px"><ADDRESS2>Rajaram Salai, KK Nagar,</ADDRESS2></div>
<div style="font-size:12px"><ADDRESS3>Chennai</ADDRESS3></div>
<div style="font-size:12px"><ADDRESS4></ADDRESS4></div>
<div style="font-size:12px"><ADDRESS5></ADDRESS5></div>

<div style="font-size:12px"><GSTNO>GST:311279613800003</GSTNO></div>

<div style="font-weight:600; margin-bottom:5px; margin-top:3px"><TITLE>Simplified Tax Invoice<</TITLE>/div>

<div style="font-weight:900; margin-bottom:5px"><DINETYPE>DINE IN</DINETYPE></div>

<hr />
<CUSTOMERINFO>
<div style="float:left; font-size:13; text-align:left; width:100%"><CUSTOMERNAME>Name:&nbsp;Raja</CUSTOMERNAME></div>
<div style="float:left; font-size:13; text-align:left; width:100%"><MOBILE>Mobile:&nbsp;9965015800</MOBILE></div>
</CUSTOMERINFO>
<hr />
<div style="float:left; font-size:13; margin-bottom:2px; margin-left:2px; margin-right:2px; margin-top:2px; text-align:left; width:100%">
<div style="float:left; width:100%">
<div style="float:left; width:50%">Bill No: <BILLNO><strong>2</strong></BILLNO></div>
<div style="float:right; text-align:right; width:50%">Date:<DATE> 21-11-2022</DATE></div>
</div>

<div style="float:left; width:100%">
<div style="float:left; width:50%">Table No:<TABLENO>B-3</TABLENO></div>

<div style="float:right; text-align:right; width:50%">Time:<BILLTIME> 10:46 AM</BILLTIME></div>
</div>

<div style="float:left; width:100%">
<div style="float:left; width:50%">Waiter:<WAITER></WAITER></div>

<div style="float:right; text-align:right; width:50%">No.of PAX:<NOOFPAX></NOOFPAX></div>
</div>

<div style="float:left; width:100%">
<div style="float:left; width:50%"><CASHIER>Cashier: Admin</CASHIER></div>

<div style="float:right; text-align:right; width:50%">&nbsp;</div>
</div>

<div style="float:left">&nbsp;</div>

<div style="float:left">&nbsp;</div>
</div>

<hr />
<div style="min-height:0px; width:100%">
<table cellpadding="0" cellspacing="0" style="font-family:Arial; font-size:var(--font13); width:100%">
	<tbody>
		<tr>
			<td>Item</td>
			<td style="width:20px">Qty.</td>
			<td style="width:40px">Price</td>
			<td style="width:55px">Amount</td>
		</tr>
		<tr>
			<td colspan="4">
			<hr /></td>
		</tr>
		<tr>
			<td>Chicken Biryani 1 KG</td>
			<td>1</td>
			<td>190.00</td>
			<td>190.00</td>
		</tr>
		<tr>
			<td>EXTRA RICE</td>
			<td>1</td>
			<td>40.00</td>
			<td>40.00</td>
		</tr>
		<tr>
			<td>Egg Kothu</td>
			<td>2</td>
			<td>80.00</td>
			<td>160.00</td>
		</tr>
		<tr>
			<td>Extra Mayonnaise</td>
			<td>1</td>
			<td>10.00</td>
			<td>10.00</td>
		</tr>
		<tr>
			<td>FISH FINGER (5 PCS)</td>
			<td>1</td>
			<td>150.00</td>
			<td>150.00</td>
		</tr>
		<tr>
			<td>Panner Butter Masala</td>
			<td>1</td>
			<td>120.00</td>
			<td>120.00</td>
		</tr>
	</tbody>
</table>
</div>

<div>
<table cellpadding="0" cellspacing="0" style="font-family:Arial; font-size:var(--font13); width:100%">
	<tbody>
		<tr>
			<td colspan="3">
			<hr /></td>
		</tr>
		<tr>
			<td>Total Qty: 7</td>
			<td>Sub Total:</td>
			<td>670.00</td>
		</tr>
	</tbody>
</table>
</div>

<div style="margin-bottom:5px; margin-left:5px; margin-right:5px; margin-top:5px">
<table cellpadding="0" cellspacing="0" style="font-family:Arial; width:100%">
	<tbody>
		<tr>
			<td colspan="2"><strong>Grand Total :</strong><strong>670.00</strong></td>
		</tr>
		<tr>
			<td>&nbsp;</td>
		</tr>
	</tbody>
</table>
</div>

<hr />
<div style="float:left; font-size:13; margin-bottom:2px; margin-left:2px; margin-right:2px; margin-top:2px; text-align:left; width:100%">Kot No: 2,1</div>

<hr />
<div style="font-size:12px">Thank you visit Again :)</div>

<div style="font-size:12px">شكرا لك الزيارة مرة أخرى :)</div>

<div style="font-weight:0; margin-bottom:5px; margin-left:5px; margin-right:5px; margin-top:5px">Printer On :26-11-2022 03:42:47 PM</div>
</div>
</div>
</body>

`

export default html;